import request from '@/utils/request'

const url = '/home/expenseaccount/'
const api = {
  submitForm (data) {
    return request({
      url: url + 'submitForm',
      method: 'post',
      data
    })
  },
  Query (data) {
    return request({
      url: url + 'getExpenseList',
      method: 'post',
      data
    })
  },
  getCompanyList (data) {
    return request({
      url: url + 'getCompanyList',
      method: 'post',
      data
    })
  },
  getFinance (data) {
    return request({
      url: url + 'getFinance',
      method: 'post',
      data
    })
  },
  saveFinance (data) {
    return request({
      url: url + 'saveFinance',
      method: 'post',
      data
    })
  },
  statistics (data) {
    return request({
      url: url + 'statistics',
      method: 'post',
      data
    })
  },
  handleDelete (data) {
    return request({
      url: url + 'handleDelete',
      method: 'post',
      data
    })
  },
  expenseDelete (data) {
    return request({
      url: url + 'expenseDelete',
      method: 'post',
      data
    })
  },
  getData (data) {
    return request({
      url: url + 'getData',
      method: 'post',
      data
    })
  },
  getData2 (data) {
    return request({
      url: url + 'getData2',
      method: 'post',
      data
    })
  },
  getData3 (data) {
    return request({
      url: url + 'getData3',
      method: 'post',
      data
    })
  },
  changeinvoice (data) {
    return request({
      url: url + 'changeinvoice',
      method: 'post',
      data
    })
  },
  getcateGoods (data) {
    return request({
      url: url + 'getcateGoods',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/expense.js